<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item
        v-for="item in breadcrumbList"
        :key="'breadcrumb_' + item.path">
<!--        {{ item.meta.title }}-->
        {{ getTitle(item) }}
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  computed: {
    breadcrumbList() {
      return this.$route.matched;
    }
  },

  methods: {
    getTitle(item) {

      if (item.meta && item.meta.names) {
        return (
          item.meta.names[this.$i18n.locale] ||
          item.meta.names["zh-CN"]
        );
      }

     // return this.$t(item.meta.title);
      return item.meta.title || "";
    }
  }
};
</script>
<style>
/* 隐藏Element UI面包屑分隔符的CSS样式 */
/* .hidden-separator {
  display: none;
} */

.orca-sds-page-header-title {
    margin-inline-end: var(--page-header-title-mr);
    font: var(--page-header-title-font);
    color: var(--page-header-title-color);
    min-height: var(--page-header-back-size);
    display: flex;
    align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Breadcrumb.vue